import EventActionProto from '../event-action-proto'


module.exports = class EventStatusReset extends EventActionProto {

    constructor(uid, data) {
        super(uid, data);
    }

    validate() { return true; }

    process() {
        gd.session.statuses.resetAndMarkOldModelsAsDeleted(this.data)

        super.process();
    }
};